import { render, staticRenderFns } from "./BlackButton.vue?vue&type=template&id=d2b9f608&scoped=true&"
import script from "./BlackButton.vue?vue&type=script&lang=js&"
export * from "./BlackButton.vue?vue&type=script&lang=js&"
import style0 from "./BlackButton.vue?vue&type=style&index=0&id=d2b9f608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b9f608",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
